import React, {useState} from "react";

const vocs = [];
const vocsInProcess = [];

function getVoc(id, loaded, setLoaded) {
    const doIt = async () => {
        if (vocsInProcess[id]) {
                vocsInProcess[id].setters.push(setLoaded)
        }
        else {
            vocsInProcess[id] = {voc: id, setters: []}
            vocs[id] = await (await fetch(`/api/nsi/oid/${id}`, {method: 'GET'})).json()
            if (!vocs[id]) {
                vocs[id] = [{}]
            }
            setLoaded(true)
            if (vocsInProcess[id]) {
                vocsInProcess[id].setters.forEach(item => item(true))}
            vocsInProcess[id] = null
        }
    }
    doIt().then(() => {
    })
}

export const useVoc =  (vocId, code, field = 'DNAME', indexName = 'CD') => {
    const [loaded, setLoaded] = useState(false)
    if (!code) {
        return field ? '' : {}
    }
    if (!vocs[vocId]) {
        getVoc(vocId, loaded, setLoaded);
        return field ? '' : {}
    }

    const node = (vocs[vocId].filter(d => d[indexName] == code) || [{}])[0]

    return field ? (node ? node[field] : "") : node
}

export const decodeVoc = (vocId, code, field) => {
    try {
    const node = (vocs[vocId].filter(d => d['value'] == code) || [{}])[0]
    return field ? (node ? node[field] : "") : node

    } catch (e) {
        return "*"
    }
}

export const decodeDataset = (dataset) => {
    if (dataset) {
        return (dataset || []).map((row, i) => ( {...row, renderCode: i}))
    } else return dataset
}

export const useFullVoc = (id) => {
    const [loaded, setLoaded] = useState(false)
    if (!vocs[id]) {
        getVoc(id, loaded, setLoaded);
        return []
    }
    return vocs[id]
}
export const VocView = ({vocId, cd}) => <> {useVoc(vocId, cd)}</>
export const RgCell = ({vocId, cd}) => useVoc(vocId, cd)